import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { formatDate, formatNumber } from '../../../helper/data-formatters.helper';

export const labourRatesListGridColumns: Array<TableColumn> = [
  {
    id: 'shopCode',
    label: 'Shop Code',
    sortDisabled: true,
  },
  {
    id: 'equipmentType',
    label: 'Equipment Type',
    sortDisabled: true,
  },
  {
    id: 'effectiveDate',
    label: 'Effective Date',
    dataType: {
      type: 'string',
      formatter: formatDate,
    },
  },
  {
    id: 'expiryDate',
    label: 'Expiry Date',
    dataType: {
      type: 'string',
      formatter: formatDate,
    },
  },
  {
    id: 'currencyCode',
    label: 'Currency',
    sortDisabled: true,
  },
  {
    id: 'regularRateUSD',
    label: 'Ordinary Rate (USD)',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
  },
  {
    id: 'regularRate',
    label: 'Ordinary Rate (Local)',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: true,
  },
  {
    id: 'overTimeRate',
    label: 'OT1',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: true,
  },
  {
    id: 'doubleTimeRate',
    label: 'OT2',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: true,
  },
  {
    id: 'miscRate',
    label: 'OT3',
    dataType: {
      type: 'number',
      formatter: formatNumber,
    },
    sortDisabled: true,
  },
  {
    id: 'actions',
    label: '',
    sortDisabled: true,
  },
];
